var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer mt-auto p-3"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-center small"},[_vm._v("Copyright © 2021 株式会社 サンワ All rights Reserved.")])])])
}]

export { render, staticRenderFns }